import { Column, Pie } from '@ant-design/plots';
import { t } from '@hefe/i18n';
import { Chart } from '@hefe/models';
import { Space, Statistic } from 'antd';
import { ReactNode } from 'react';

interface ChartComponentProps {
  chart: Chart;
}

export default function ChartComponent(props: ChartComponentProps) {
  const { chart } = props;

  const PieChart = (): ReactNode => {
    return (
      <Pie
        data={chart.data}
        angleField="value"
        colorField="label"
        tooltip="value"
        label={{
          text: 'value',
          style: {
            fontWeight: 'bold',
          },
        }}
        legend={{
          color: {
            title: true,
            position: 'bottom',
            rowPadding: 5,
          },
        }}
      />
    );
  };

  const BarChart = (): ReactNode => {
    return (
      <Column
        data={chart.data}
        xField="label"
        yField="value"
        tooltip="value"
        label={{
          text: 'value',
          style: {
            fontWeight: 'bold',
          },
          textBaseline: 'bottom',
        }}
        legend={{
          color: {
            title: true,
            position: 'bottom',
            rowPadding: 5,
          },
        }}
      />
    );
  };

  const NumbersChart = (): ReactNode => {
    return (
      <div>
        <Space direction="vertical">
          {chart?.data?.map((item, index) => (
            <Statistic key={index} title={item.label} value={item.value} />
          ))}
        </Space>
      </div>
    );
  };

  if (chart?.data?.length === 0) {
    return <div>{t('information_texts.no_data')}</div>;
  }

  switch (chart.type) {
    case 'bar':
      return <BarChart />;
    case 'pie':
      return <PieChart />;
    case 'numbers':
      return <NumbersChart />;
    default:
      return <div>Unknown Chart Type</div>;
  }
}
